import secureLocalStorage from "react-secure-storage";
import React, { Component, PureComponent } from "react";
import { process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import Api from "../../Services/Api";
import ExistingControlCell from "../Tenant/Component/ExistingControlCell";
import ImpactEditComponent from "../Tenant/Component/ImpactEditComponent";
import PrePostComponenant from "../Tenant/Component/PrePostComponenant";
import RiskCauseCell from "../Tenant/Component/RiskCauseCell";
import RiskDescriptionCell from "../Tenant/Component/RiskDescriptionCell";
import StatusComponent from "../Tenant/Component/StatusComponent";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import TextNarrative from "./TextNarrative";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import "hammerjs";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import AddToCart from "../Tenant/AddToCart";
import RiskColumns from "../Tenant/RiskColumns.json";
import SkeletonReport from "./SkeletonReport";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";
export default class DataReportForRisk extends Component {
  gridPDFExport;
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 15,
        skip: 0,
      },
      loader: false,
      riskList: [],
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      isReportLoaded: false,
      chartData: {},
      impactMaster: [],
    };
    this._exporterRisk = React.createRef();
  }

  componentDidUpdate() {}
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
      this.init(this.props.chartInputs);
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
        });
        this.init(response.chartData[0]);
        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };
  init = async (chartData) => {
    if (
      chartData &&
      !chartData.isActionWidget &&
      chartData.datasetResponseRisk
    ) {
      if (chartData.datasetResponseRisk.riskRegister) {
        let riskRegister = chartData.datasetResponseRisk.riskRegister;
        riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.closedDate) {
                      riskReg.closedDate = new Date(riskReg.closedDate);
                    } else {
                      riskReg.closedDate = null;
                    }
                    if (riskReg.updatedDate) {
                      var time = moment(riskReg.updatedDate).toDate();
                      time.setHours(0);
                      time.setMinutes(0);
                      time.setSeconds(0);
                      time.setMilliseconds(0);
                      let updatedDate = time;
                      riskReg.updatedDate = riskReg.updatedDate
                        ? new Date(updatedDate)
                        : "";
                    } else {
                      riskReg.updatedDate = null;
                    }
                    if (riskReg.createdDate) {
                      var time = moment(riskReg.createdDate).toDate();
                      time.setHours(0);
                      time.setMinutes(0);
                      time.setSeconds(0);
                      time.setMilliseconds(0);
                      let createdDate = time;
                      riskReg.createdDate = riskReg.createdDate
                        ? new Date(createdDate)
                        : "";
                    } else {
                      riskReg.createdDate = null;
                    }
          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNames"] = riskReg.riskTypeNames.toString();
          }
        });
        let impactMaster = [];
        if (riskRegister && riskRegister.length > 0) {
          impactMaster = riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(riskRegister);
        await this.createDynamicCols(riskRegister);

        var riskData = riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );

        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          chartData: this.props.chartInputs ? this.props.chartInputs : {},
          isReportLoaded: true,
        });
      }
    }
  };

  createDynamicDropdowns = async (products) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName === item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? parseInt(temp.multiText) : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue) {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  //Impact
  createDynamicCols = async (products) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name + "_" + item.type)) {
              impactColumn.push(item.name + "_" + item.type);
            }
          } else {
            impactColumn.push(item.name + "_" + item.type);
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter(
            (item) => item.name + "_" + item.type === col
          );
          if (temp.length > 0) {
            res[col] =
              temp[0].type == "Post" ? temp[0].postImpactValue : temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          cell={(props) => (
            <ImpactEditComponent {...props} onEditCell={this.onEditCell} />
          )}
          filter={"numeric"}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };

  getImpactUnit = (impact) => {
    var impactTemp = this.state.impactMaster.find(
      (item) => item.name + "_" + item.type === impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? impactTemp.units : "";
      res = impactTemp.name + " / " + unit + " (" + impactTemp.type + ")";
    }
    return res;
  };

  mitigationFilterQuery() {}

  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }

  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
  };
  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Risk",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId||this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  shareFile = (widgetId) => {
    this.state.riskList.map((riskReg) => {
      riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
      Object.keys(riskReg).map(function (field) {
        if (RiskColumns.hasOwnProperty(field)) {
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
        } else {
          //Custom field
          let arr = riskReg.customFields ? riskReg.customFields : [];
          let temp = arr.find((item) => item.fieldName == field);
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames.toString();
            } else if (temp.inputType === "Single Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
            } else if (temp.inputType === "Free Text") {
              riskReg[field] = temp.multiText;
            } else if (temp.inputType === "Numeric") {
              riskReg[field] = temp.multiText ? parseInt(temp.multiText) : "";
            } else if (temp.inputType === "Date") {
              riskReg[field] = temp.multiText
                ? new Date(temp.multiText)
                : undefined;
            }
          } else {
            //Imapct value
            let arrImp = riskReg.impactResponse ? riskReg.impactResponse : [];
            let imp = arrImp.find((item) => item.name == field);
            if (imp) {
              let str = imp.value.split("_");
              riskReg[field] = str[0] + "(" + str[1] + ")";
            }
          }
        }
      });
    });
    this._exporterRisk.current
      .toDataURL(this.state.riskList)
      .then((dataURL) => {
        this.sendMail(dataURL, widgetId);
      });
  };

  sendMail = async (dataURL, widgetId) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

    var file = this.dataURLtoFile(dataURL, widgetName + ".xlsx");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  //Excel
  onExportExcelClick = () => {
    this.state.riskList.map((riskReg) => {
      riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
      Object.keys(riskReg).map(function (field) {
        if (RiskColumns.hasOwnProperty(field)) {
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
        } else {
          //Custom field
          let arr = riskReg.customFields ? riskReg.customFields : [];
          let temp = arr.find((item) => item.fieldName == field);
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames.toString();
            } else if (temp.inputType === "Single Drop Down") {
              riskReg[field] = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
            } else if (temp.inputType === "Free Text") {
              riskReg[field] = temp.multiText;
            } else if (temp.inputType === "Numeric") {
              riskReg[field] = temp.multiText ? parseInt(temp.multiText) : "";
            } else if (temp.inputType === "Date") {
              riskReg[field] = temp.multiText
                ? new Date(temp.multiText)
                : undefined;
            }
          } else {
            //Imapct value
            let arrImp = riskReg.impactResponse ? riskReg.impactResponse : [];
            let imp = arrImp.find((item) => item.name == field);
            if (imp) {
              let str = imp.value.split("_");
              riskReg[field] = str[0] + "(" + str[1] + ")";
            }
          }
        }
      });
    });

    this._exporterRisk.current.save(this.state.riskList);
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  onPDFExportClick = () => {
    if (this.gridPDFExport) {
      this.gridPDFExport.save();
    }
    this.pdfTitlePopupClose();
  };

  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  onEditCell() {}
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
   editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    let isPrime = secureLocalStorage.getItem("isPrime") === true ? true : false;
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else {
      return (
        <div id="capture">
          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}
          {this.props.flag ? (
            <ul className="WidgetActions">
                {this.props.isTenentAdmin ||
                            chartData.createdBy == userId ||
                            (this.props.selectedDashboard &&
                              this.props.selectedDashboard.createdBy == userId)
                              ? !this.props.isFreezeDS && (
                                  <li onClick={() => this.editWidgetOpen(chartData)}>
                                    <a>
                                      <img src={Images.EDITICON} alt="Edit" width="14" />
                                    </a>
                                  </li>
                                )
                              : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Add to home"
                  onClick={() => this.moveToHome(chartData)}
                >
                  <a>
                    <img src={Images.HOME} alt="Download" width="14" />
                  </a>
                </li>
              )}

              <li onClick={this.onExportExcelClick}>
                <a>
                  <img src={Images.XLSX} alt="Download" width="14" />
                </a>
              </li>
              {/* <li onClick={this.pdfTitlePopupOpen}>
              <a>
                <img src={Images.PDF} alt="Download" width="14" />
              </a>
            </li> */}
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li onClick={() => this.openAddToCart(chartData.dataSourceId)}>
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.shareFile(chartData.widgetId)}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions">
              {/* <li
              title="Remove from home"
              onClick={() => this.removeFromHome(chartData)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li> */}
            </ul>
          )}

          <div
            id={"c" + chartData.widgetId}
            className="tblCont riskRegister dataGrids reportsGrid"
            key={chartData.title}
          >
            <div className="titleBG">
              <span>{chartData.title}</span>
              {/* <small className="createdDate">{CreatedDate}</small> */}
            </div>
            <ExcelExport
              data={this.state.riskList}
              fileName={
                chartData.widgetName
                  ? chartData.widgetName.replace(".", " ")
                  : "Risk" + ".xlsx"
              }
              ref={this._exporterRisk}
              headerPaddingCellOptions={{
                background: "#ff0000",
              }}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.riskList, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
                // expandField="expanded"
                // onExpandChange={this.expandChange}
                // detail={MitigationDetails}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organizationUnitName"
                  title="Workstream"
                  width="100px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  locked={true}
                  field="number"
                  title="Action Number"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskTitle"
                  title="Risk Title*"
                  width="150px"
                  locked={true}
                  // columnMenu={ColumnMenu}
                />

                <Column
                  field="isOpportunity"
                  title="T/O"
                  width="85px"
                  // columnMenu={ColumnMenu}
                  cell={(props) =>
                    props.dataItem.isOpportunity === "Threat" ? (
                      <td>{props.dataItem.isOpportunity}</td>
                    ) : (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.isOpportunity}
                        </span>
                      </td>
                    )
                  }
                />
                <Column
                  field="name"
                  title="Risk"
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <RiskDescriptionCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskTypeNames"
                  title="Risk Type"
                  width="150px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="mitigationCount"
                  title="Action Count"
                  width="80px"
                  f
                />
                {this.state.dropdownColumns}
                <Column
                  field="cause"
                  title="Cause"
                  width="100px"
                  editable={false}
                  cell={(props) => (
                    <RiskCauseCell {...props} onEditCell={this.onEditCell} />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="existingControl"
                  title="Existing Control"
                  width="100px"
                  editable={false}
                  cell={(props) => (
                    <ExistingControlCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="frequency"
                  title="Pre-Probability (%)"
                  width="80px"
                  filter={"numeric"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="currentProbability"
                  title="Current Probability (%)"
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="turquoiseBlue">
                        {props.dataItem.currentProbability}
                      </span>
                    </td>
                  )}
                />
                <Column
                  field="reductionProbability"
                  title="Post-Probability (%)"
                  width="75px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="yellowCell">
                        {props.dataItem.reductionProbability}
                      </span>
                    </td>
                  )}
                  filter={"numeric"}
                />

                <Column
                  field="pre"
                  title="pre"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.props.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.props.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.props.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                <Column
                  field="current"
                  title="Current"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.props.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.props.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.props.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                <Column
                  field="post"
                  title="post"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.props.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.props.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.props.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                {/* <Column
              field="overAll"
              title="OverAll Impact"
              width="100px"
              sortable={false}
              editable={false}
              cell={(props) => (
                <OverallComponenant {...props} onEditCell={this.onEditCell} />
              )}
            /> */}
                {/* New  */}

                <Column
                  field="preRiskScore"
                  title="Risk Score (Pre)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                />

                {isPrime && (
                  <Column
                    field="preWeightedRiskScore"
                    title="Prime Risk Score (Pre)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span>
                          {props.dataItem.isPrimeWorkstreams &&
                          secureLocalStorage.getItem("isPrime") === true
                            ? props.dataItem.preWeightedRiskScore
                            : ""}
                        </span>
                      </td>
                    )}
                  />
                )}

                <Column
                  field="currentRiskScore"
                  title="Risk Score (Current)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="turquoiseBlue">
                        {props.dataItem.currentRiskScore}
                      </span>
                    </td>
                  )}
                />

                {isPrime && (
                  <Column
                    field="currentWeightedRiskScore"
                    title="Prime Risk Score (Current)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.isPrimeWorkstreams &&
                          secureLocalStorage.getItem("isPrime") === true
                            ? props.dataItem.currentWeightedRiskScore
                            : ""}
                        </span>
                      </td>
                    )}
                  />
                )}

                <Column
                  field="postRiskScore"
                  title="Risk Score (Post)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="yellowCell">
                        {props.dataItem.postRiskScore}
                      </span>
                    </td>
                  )}
                />

                {isPrime && (
                  <Column
                    field="postWeightedRiskScore"
                    title="Prime Risk Score (Post)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.postWeightedRiskScore}
                        </span>
                      </td>
                    )}
                  />
                )}
                {/* End  */}
                {this.state.impactColumns}
                <Column
                  field="impactComments"
                  title="Consequences"
                  width="120px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="progress"
                  title="Progress Status"
                  width="120px"
                />
                <Column
                  field="proximityDate"
                  title="Proximity Date"
                  width="120px"
                  editor="date"
                  filter={"date"}
                  editable={false}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="owner"
                  title="Owner"
                  width="120px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskFieldsCompletion"
                  title="% of fields completed"
                  width="120px"
                  editable={false}
                />
                <Column
                  field="createdDate"
                  title="Created Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  width="120px"
                />
                <Column
                  field="createdByName"
                  title="Created By"
                  width="120px"
                />
                <Column
                  field="updatedDate"
                  title="updated Date"
                  width="120px"
                  format="{0:dd-MMM-yyyy}"
                />
                <Column field="updatedBy" title="updated By" width="120px" />
                <Column
                  field="isClosed"
                  title="Status"
                  width="70px"
                  // editor="boolean"
                  editable={false}
                  cell={(props) => (
                    <StatusComponent {...props} onEditCell={this.onEditCell} />
                  )}
                  filter={"boolean"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="closedDate"
                  title="closed Date"
                  width="120px"
                  format="{0:dd-MMM-yyyy}"
                />
              </Grid>
            </ExcelExport>

            <GridPDFExport
              ref={(pdfExport) => (this.gridPDFExport = pdfExport)}
              fileName={chartData.widgetName ? chartData.widgetName : "Risk"}
              margin="1cm"
              date={new Date()}
              // paperSize={["1000mm", "400mm"]}
              paperSize={"auto"}
              title={this.state.title + " " + CreatedDate}
              repeatHeaders={true}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.riskList, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
                // expandField="expanded"
                // onExpandChange={this.expandChange}
                // detail={MitigationDetails}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organizationUnitName"
                  title="Workstream"
                  width="100px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  locked={true}
                  field="number"
                  title="Action Number"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskTitle"
                  title="Risk Title*"
                  width="150px"
                  locked={true}
                  // columnMenu={ColumnMenu}
                />

                <Column
                  field="isOpportunity"
                  title="T/O"
                  width="85px"
                  // columnMenu={ColumnMenu}
                  cell={(props) =>
                    props.dataItem.isOpportunity === "Threat" ? (
                      <td>{props.dataItem.isOpportunity}</td>
                    ) : (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.isOpportunity}
                        </span>
                      </td>
                    )
                  }
                />
                <Column
                  field="name"
                  title="Risk"
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <RiskDescriptionCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskTypeNames"
                  title="Risk Type"
                  width="150px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="mitigationCount"
                  title="Action Count"
                  width="80px"
                  f
                />
                {this.state.dropdownColumns}
                <Column
                  field="cause"
                  title="Cause"
                  width="100px"
                  editable={false}
                  cell={(props) => (
                    <RiskCauseCell {...props} onEditCell={this.onEditCell} />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="existingControl"
                  title="Existing Control"
                  width="100px"
                  editable={false}
                  cell={(props) => (
                    <ExistingControlCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="frequency"
                  title="Pre-Probability (%)"
                  width="80px"
                  filter={"numeric"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="currentProbability"
                  title="Current Probability (%)"
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="turquoiseBlue">
                        {props.dataItem.currentProbability}
                      </span>
                    </td>
                  )}
                />
                <Column
                  field="reductionProbability"
                  title="Post-Probability (%)"
                  width="75px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="yellowCell">
                        {props.dataItem.reductionProbability}
                      </span>
                    </td>
                  )}
                  filter={"numeric"}
                />

                <Column
                  field="pre"
                  title="pre"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.props.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.props.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.props.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                <Column
                  field="current"
                  title="Current"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.state.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.state.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.state.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                <Column
                  field="post"
                  title="post"
                  width="75px"
                  editable={false}
                  sortable={false}
                  cell={(props) => (
                    <PrePostComponenant
                      {...props}
                      onEditCell={this.onEditCell}
                      HeatMapConfigDataOpportunity={
                        this.props.HeatMapConfigDataOpportunity
                      }
                      HeatMapConfigDataThreat={
                        this.props.HeatMapConfigDataThreat
                      }
                      dynamicHeatmapProbabilityRange={
                        this.props.dynamicHeatmapProbabilityRange
                      }
                    />
                  )}
                />
                {/* <Column
              field="overAll"
              title="OverAll Impact"
              width="100px"
              sortable={false}
              editable={false}
              cell={(props) => (
                <OverallComponenant {...props} onEditCell={this.onEditCell} />
              )}
            /> */}
                {/* New  */}

                <Column
                  field="preRiskScore"
                  title="Risk Score (Pre)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                />

                {isPrime && (
                  <Column
                    field="preWeightedRiskScore"
                    title="Prime Risk Score (Pre)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span>
                          {props.dataItem.isPrimeWorkstreams &&
                          secureLocalStorage.getItem("isPrime") === true
                            ? props.dataItem.preWeightedRiskScore
                            : ""}
                        </span>
                      </td>
                    )}
                  />
                )}

                <Column
                  field="currentRiskScore"
                  title="Risk Score (Current)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="turquoiseBlue">
                        {props.dataItem.currentRiskScore}
                      </span>
                    </td>
                  )}
                />

                {isPrime && (
                  <Column
                    field="currentWeightedRiskScore"
                    title="Prime Risk Score (Current)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.isPrimeWorkstreams &&
                          secureLocalStorage.getItem("isPrime") === true
                            ? props.dataItem.currentWeightedRiskScore
                            : ""}
                        </span>
                      </td>
                    )}
                  />
                )}

                <Column
                  field="postRiskScore"
                  title="Risk Score (Post)"
                  filter={"numeric"}
                  width="80px"
                  editable={false}
                  cell={(props) => (
                    <td>
                      <span className="yellowCell">
                        {props.dataItem.postRiskScore}
                      </span>
                    </td>
                  )}
                />

                {isPrime && (
                  <Column
                    field="postWeightedRiskScore"
                    title="Prime Risk Score (Post)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.postWeightedRiskScore}
                        </span>
                      </td>
                    )}
                  />
                )}
                {/* End  */}
                {this.state.impactColumns}
                <Column
                  field="impactComments"
                  title="Consequences"
                  width="120px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="progress"
                  title="Progress Status"
                  width="120px"
                />
                <Column
                  field="proximityDate"
                  title="Proximity Date"
                  width="120px"
                  editor="date"
                  filter={"date"}
                  editable={false}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="owner"
                  title="Owner"
                  width="120px"
                  editable={false}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskFieldsCompletion"
                  title="% of fields completed"
                  width="120px"
                  editable={false}
                />
                <Column
                  field="createdDate"
                  title="Created Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  width="120px"
                />
                <Column
                  field="createdByName"
                  title="Created By"
                  width="120px"
                />
                <Column
                  field="updatedDate"
                  title="updated Date"
                  width="120px"
                  format="{0:dd-MMM-yyyy}"
                />
                <Column field="updatedBy" title="updated By" width="120px" />
                <Column
                  field="isClosed"
                  title="Status"
                  width="70px"
                  // editor="boolean"
                  editable={false}
                  cell={(props) => (
                    <StatusComponent {...props} onEditCell={this.onEditCell} />
                  )}
                  filter={"boolean"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="closedDate"
                  title="closed Date"
                  width="120px"
                  format="{0:dd-MMM-yyyy}"
                />
              </Grid>
            </GridPDFExport>
            <div className="wgHeader">
              <h4>Dataset: {chartData.dataSource} </h4>
            </div>
            <TextNarrativeExport
              chartData={chartData}
              isHidden={this.state.isHidden}
            />
          </div>
          <ReportUpdate
            chartData={chartData}
            ref="childUpdateWidget"
            updateChartData={this.updateChartData}
          />
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            show={this.state.openPdfTitlePopup}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="addTypeForm">
              <div className="fieldCont">
                <label>Enter Title</label>
                <input
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                  placeholder="Title"
                  value={this.state.title}
                  required
                />
              </div>
              <div className="btnGroup">
                <button
                  disabled={!this.state.title}
                  className="btnPrimary"
                  onClick={this.onPDFExportClick}
                >
                  Export
                </button>
                <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Popup>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>
        </div>
      );
    }
  }
}
